import React, { useState, useMemo, useEffect } from "react";
import { Button, SwipeableDrawer, styled, Box, Divider, Avatar } from "@mui/material";
import { formatNumberInString, getAvatarName } from "../../../utils";
import { format } from "date-fns";
import { useSelector } from "react-redux";

const CustomSwipeableDrawer = styled(SwipeableDrawer)`
    & .MuiDrawer-paperAnchorBottom {
        border-top-left-radius: 22px !important;
        border-top-right-radius: 22px !important;
        height: 94%;
        background-color: #3A3A3A;
    }
`;


const AuditionView = ({ open, onClose, data }) => {
    const profileData = useSelector(state => state.recruiterProfileReducer?.profileData);
    const userProfile = profileData?.userProfile;

    const fullName = `${profileData?.firstName} ${profileData?.lastName ?? ""}`;
    const profilePic = userProfile?.profilePic?.url;


    if (!data) return;

    return (
        <CustomSwipeableDrawer anchor="bottom" open={open} onClose={onClose}>
            <Box className="py-4 px-5" sx={{ width: 'auto' }}>
                <div className="w-[54px] h-1 bg-[#D9D9D9] rounded-sm mx-auto " />
                <div className="py-5 text-white overflow-hidden">
                    <div className="flex justify-between items-center my-2">
                        <div className="text-white bg-[#00000065] rounded-[3px] text-[12px] text-center px-5 py-[4px] font-['Poppins-Medium']">{data?.projectCategory?.name}</div>
                        <div className="flex gap-1 items-center">
                            <div className="text-white bg-[#00000065] rounded-[3px] text-[12px] text-center px-5 py-[4px] font-['Poppins-Medium']">{data?.profileCategory?.name}</div>
                            <div className="text-white bg-[#00000065] rounded-[3px] text-[12px] text-center px-5 py-[4px] font-['Poppins-Medium']">{data?.roleType?.name}</div>
                        </div>
                    </div>
                    <h1 className="text-white rounded-[6px] my-5 text-[24px] font-['CG-Medium']">{`${data?.roleType?.name} casting for ${data?.projectCategory?.name}`}</h1>
                    <div className="flex items-center justify-between my-2">
                        <p className="text-[12px] font-['CG-Regular'] font-[400]">
                            {data?.gender}, {"  "} Age: {data?.minAge}-{data?.maxAge}
                        </p>
                        {data?.auditionLocation ? (
                            <p className="text-[12px] font-['CG-Regular'] font-[400]">
                                {data?.auditionLocation}
                            </p>
                        ) : null}
                    </div>
                    <Divider className="my-2" />
                    <div className="scroll h-[52vh]">
                        {data?.project?.title ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Project -</span> {data?.project?.title}
                            </p>
                        ) : null}
                        {data?.project?.description ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Project Description -</span> {data?.project?.description}
                            </p>
                        ) : null}
                        {data?.language ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Language -</span> {data?.language}
                            </p>
                        ) : null}
                        {data?.numberOfDays ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Duration -</span> {data?.numberOfDays}
                            </p>
                        ) : null}
                        {data?.shootLocation ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Shoot Location -</span> {data?.shootLocation}
                            </p>
                        ) : null}
                        {!data.negotiable && (data?.minBudget || data?.maxBudget) ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Budget -</span> {formatNumberInString(+data?.minBudget || 0)} - {formatNumberInString(+data?.maxBudget || 0)}
                            </p>
                        ) : null}
                        {data.negotiable ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Budget -</span> Depends on artist
                            </p>
                        ) : null}
                        {data?.payBasis ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Pay Basis -</span> {data?.payBasis}
                            </p>
                        ) : null}
                        {data?.characterDescription ? (
                            <p className="text-[16px] font-['CG-Regular'] my-2">
                                <span className="font-['CG-Medium'] font-[500]">Requirements -</span> {data?.characterDescription}
                            </p>
                        ) : null}
                    </div>
                    <Divider className="my-2" />
                    <div className="flex justify-between gap-1">
                        <h2 className="font-['Poppins-Regular'] font-[400] text-[10px] text-[#FFFFFF]">Posted: {format(new Date(data?.addedAt), "dd MMMM yyyy")}</h2>
                        <h2 className="font-['Poppins-Regular'] font-[400] text-[10px] text-[#ffffff]">Expires: {format(new Date(data?.endDate), "dd MMMM yyyy")}</h2>
                    </div>
                    <Divider className="my-2" />
                    <div className="flex gap-2 my-4">
                        <Avatar src={profilePic} className="w-[30px] h-[30px] text-[14px]">{getAvatarName(fullName)}</Avatar>
                        <div className="flex flex-col justify-between">
                            <h2 className="font-['Poppins-Medium'] font-[500] text-[11px]">{fullName}</h2>
                            <span className="text-[10px] font-['Poppins-Regular']">{userProfile?.profileCategory?.name}r</span>
                        </div>
                    </div>
                </div>
            </Box>
        </CustomSwipeableDrawer>
    );
}

export default React.memo(AuditionView, (prevProps, nextProps) => {
    return prevProps.open === nextProps.open || prevProps.data === nextProps.data;
});